export default class FetchRecentlyMentionedAgentIds {
  constructor(context) {
    this.context = context;
  }

  run() {
    this.context.stores.recentlyMentionedAgentIds.set(this.context.stores.localRecentlyMentionedAgentIds.get());
  }
}
